import styled from 'styled-components';
import { PrimaryButton, Button, SecondaryButton } from 'ui/button';
import { Refresh16 } from 'ui/icons';
import { body2, caption, colors, fontWeights, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledSidePanel = styled.div<{ navBarHeight: number }>`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  padding: 0;
  width: ${pxToRem(192)};
  position: sticky;
  top: ${({ navBarHeight }) => pxToRem(navBarHeight + 16)};
`;

export const StyledSidePanelSection = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};

  &:not(:first-child) {
    border-top: ${spacing.single} solid ${colors.borderPrimary};
  }
`;

export const StyledButtonGroup = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  padding: 0;
`;

export const StyledKeyValueGroup = styled.div`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: ${spacing.eighth};
  padding: 0;
`;

export const StyledKey = styled.div`
  ${caption}
  color: ${colors.textSecondary};
`;

export const StyledProjectValue = styled.div`
  ${body2}
  font-feature-settings: 'tnum';
  font-variant-numeric: lining-nums tabular-nums;
  font-weight: ${fontWeights.semiBold};
`;

export const StyledActionMenuButton = styled(Button)`
  width: 100%;
  justify-content: stretch;
  > span:first-child {
    flex: 1 0 auto;
  }
`;

export const StyledRefreshButton = styled(PrimaryButton)`
  width: 100%;
  justify-content: stretch;
  > span:first-child {
    flex: 1 0 auto;
  }
  > :not(:first-child) {
    flex: 0 0 auto;
  }
`;

export const StyledUpdateButton = styled(SecondaryButton)`
  width: 100%;
`;

export const AnimRefresh16 = styled(Refresh16)`
  transform-origin: center;
  animation: rotate 1s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
